import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { rolde } from '../yetki';

export default function Ayarlar() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [const_, setConst] = useState({ belde:'', belediye:'', baskan:'', adres:'', telefon:'', faks:'', web:'' });
  const [smtp, setSmtp] = useState({ smtp_host:'', smtp_port:587, smtp_user:'', smtp_pass:'', smtp_from:'', smtp_ssl:false });
  const [sms, setSms] = useState({ aktif:false, kullanici_adi:'', sifre:'', user_code:'', account_id:'', originator:'' });
  const [smsKredi, setSmsKredi] = useState(null);
  const [smsTelefon, setSmsTelefon] = useState('');
  const [smsMesaj, setSmsMesaj] = useState('');
  const [smsTestYukleniyor, setSmsTestYukleniyor] = useState(false);
  const [sifre, setSifre] = useState({ eski_sifre:'', yeni_sifre:'', tekrar:'' });
  const [mesaj, setMesaj] = useState('');
  const [hata, setHata] = useState('');

  useEffect(() => {
    api.get('/tanimlar/const').then(r => {
      if (r.data) {
        const { smtp_host, smtp_port, smtp_user, smtp_from, bildirim_aktif, ...rest } = r.data;
        setConst(rest);
        setSmtp({ smtp_host: smtp_host||'', smtp_port: smtp_port||587, smtp_user: smtp_user||'', smtp_pass:'', smtp_from: smtp_from||'', smtp_ssl: parseInt(smtp_port)===465 });
      }
    });
    if (rolde(kullanici, 'admin', 'mudur')) {
      api.get('/sms/ayarlar').then(r => setSms({ ...r.data, sifre: '' })).catch(() => {});
    }
  }, [kullanici?.rol]);

  const constKaydet = async (e) => {
    e.preventDefault(); setHata(''); setMesaj('');
    try { await api.put('/tanimlar/const', const_); setMesaj('Belediye bilgileri güncellendi!'); }
    catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const smtpKaydet = async (e) => {
    e.preventDefault(); setHata(''); setMesaj('');
    try {
      const port = smtp.smtp_ssl ? 465 : (smtp.smtp_port || 587);
      await api.put('/tanimlar/smtp', { ...smtp, smtp_port: port });
      setMesaj('SMTP ayarları kaydedildi!');
      setSmtp(prev => ({ ...prev, smtp_pass: '' }));
    }
    catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const [testEmail, setTestEmail] = useState('');
  const [testYukleniyor, setTestYukleniyor] = useState(false);

  const smtpTest = async () => {
    if (!testEmail) { setHata('Test için e-posta adresi girin'); return; }
    setHata(''); setMesaj(''); setTestYukleniyor(true);
    try {
      const res = await api.post('/tanimlar/smtp-test', { hedef: testEmail });
      setMesaj(res.data.mesaj || 'Test e-postası gönderildi!');
    }
    catch (err) { setHata(err.response?.data?.hata || 'Test gönderilemedi'); }
    finally { setTestYukleniyor(false); }
  };

  const smsKaydet = async (e) => {
    e.preventDefault(); setHata(''); setMesaj('');
    try {
      await api.put('/sms/ayarlar', sms);
      setMesaj('SMS ayarları kaydedildi!');
      setSms(prev => ({ ...prev, sifre: '' }));
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const smsKrediSorgula = async () => {
    setHata(''); setSmsKredi(null);
    try {
      const r = await api.get('/sms/kredi');
      if (r.data.success) setSmsKredi(r.data.kredi);
      else setHata(r.data.error || 'Kredi sorgulanamadı');
    } catch (e) { setHata(e.response?.data?.hata || 'Kredi sorgulanamadı'); }
  };

  const smsTeste = async () => {
    if (!smsTelefon || !smsMesaj) { setHata('Telefon ve mesaj zorunludur'); return; }
    setHata(''); setSmsTestYukleniyor(true);
    try {
      const r = await api.post('/sms/test', { telefon: smsTelefon, mesaj: smsMesaj });
      if (r.data.success) setMesaj('Test SMS başarıyla gönderildi!');
      else if (r.data.skipped) setHata(`Atlandı: ${r.data.reason}`);
      else setHata(`Hata: ${r.data.error_message}`);
    } catch (e) { setHata(e.response?.data?.hata || 'Test gönderilemedi'); }
    finally { setSmsTestYukleniyor(false); }
  };

  const sifreDegistir = async (e) => {
    e.preventDefault(); setHata(''); setMesaj('');
    if (sifre.yeni_sifre !== sifre.tekrar) return setHata('Yeni şifreler eşleşmiyor!');
    try { await api.post('/auth/sifre-degistir', { eski_sifre: sifre.eski_sifre, yeni_sifre: sifre.yeni_sifre }); setMesaj('Şifre değiştirildi!'); setSifre({ eski_sifre:'', yeni_sifre:'', tekrar:'' }); }
    catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  return (
    <div>
      <h2 style={{color:'#1a237e', marginBottom:'20px'}}>⚙️ Sistem Ayarları</h2>
      {mesaj && <div className="alert alert-success">{mesaj}</div>}
      {hata && <div className="alert alert-error">{hata}</div>}

      {rolde(kullanici, 'admin') && (
        <div className="card">
          <div className="card-header"><span className="card-title">Belediye Bilgileri</span></div>
          <form onSubmit={constKaydet}>
            <div className="form-grid">
              <div className="form-group"><label>Belde Adı</label><input value={const_.belde || ''} onChange={e => setConst({...const_, belde: e.target.value})} placeholder="ÜNYE" /></div>
              <div className="form-group"><label>Tam Belediye Adı</label><input value={const_.belediye || ''} onChange={e => setConst({...const_, belediye: e.target.value})} placeholder="ÜNYE BELEDİYESİ" /></div>
              <div className="form-group"><label>Belediye Başkanı</label><input value={const_.baskan || ''} onChange={e => setConst({...const_, baskan: e.target.value})} placeholder="Ad Soyad" /></div>
              <div className="form-group" style={{gridColumn:'1/-1'}}><label>Adres</label><textarea value={const_.adres || ''} onChange={e => setConst({...const_, adres: e.target.value})} rows={2} /></div>
              <div className="form-group"><label>Telefon</label><input value={const_.telefon || ''} onChange={e => setConst({...const_, telefon: e.target.value})} /></div>
              <div className="form-group"><label>Faks</label><input value={const_.faks || ''} onChange={e => setConst({...const_, faks: e.target.value})} /></div>
              <div className="form-group"><label>Web Sitesi</label><input value={const_.web || ''} onChange={e => setConst({...const_, web: e.target.value})} /></div>
            </div>
            <div style={{marginTop:'16px', display:'flex', justifyContent:'flex-end'}}>
              <button type="submit" className="btn btn-primary">💾 Kaydet</button>
            </div>
          </form>
        </div>
      )}

      {rolde(kullanici, 'admin') && (
        <div className="card">
          <div className="card-header"><span className="card-title">📧 SMTP Ayarları</span></div>
          <form onSubmit={smtpKaydet}>
            <p style={{fontSize:'12px',color:'#666',marginBottom:'16px'}}>
              Şifre sıfırlama bağlantılarının e-posta ile gönderilmesi için SMTP sunucu bilgilerini girin.
              Burada girilen değerler, sunucudaki SMTP_* ortam değişkenlerinin önüne geçer.
            </p>
            <div className="form-grid">
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>Sunucu Adresi *</label>
                <input value={smtp.smtp_host||''} onChange={e=>setSmtp({...smtp,smtp_host:e.target.value})} placeholder="mail.kurumsaleposta.com" required />
              </div>
              <div className="form-group">
                <label>Port</label>
                <input type="number" value={smtp.smtp_port||587} onChange={e=>setSmtp({...smtp,smtp_port:Number(e.target.value)})} />
              </div>
              <div className="form-group">
                <label>Kullanıcı Adı</label>
                <input value={smtp.smtp_user||''} onChange={e=>setSmtp({...smtp,smtp_user:e.target.value})} placeholder="sifresifirlama@unye.bel.tr" />
              </div>
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>Şifre <span style={{color:'#999',fontWeight:'400'}}>(boş bırakılırsa değişmez)</span></label>
                <input type="password" value={smtp.smtp_pass||''} onChange={e=>setSmtp({...smtp,smtp_pass:e.target.value})} placeholder="••••••• (ayarlı, boş bırakılırsa korunur)" />
              </div>
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>Gönderen E-posta</label>
                <input value={smtp.smtp_from||''} onChange={e=>setSmtp({...smtp,smtp_from:e.target.value})} placeholder="sifresifirlama@unye.bel.tr" />
              </div>
              <div className="form-group" style={{gridColumn:'1/-1',display:'flex',alignItems:'flex-start',gap:'10px'}}>
                <input type="checkbox" id="smtp_ssl" checked={!!smtp.smtp_ssl} onChange={e=>setSmtp({...smtp,smtp_ssl:e.target.checked})} style={{width:'18px',height:'18px',marginTop:'2px',flexShrink:0}} />
                <label htmlFor="smtp_ssl" style={{cursor:'pointer',fontSize:'13px'}}>
                  <strong>SSL Gerekli</strong> <span style={{color:'#666'}}>(sunucu başlangıçta doğrudan TLS bekliyorsa işaretleyin — genelde 465 portu; 587 için işaretsiz bırakın, STARTTLS otomatik denenir)</span>
                </label>
              </div>
            </div>
            <div style={{marginTop:'16px', display:'flex', justifyContent:'flex-end'}}>
              <button type="submit" className="btn btn-primary">💾 Kaydet</button>
            </div>
          </form>
          <div style={{borderTop:'1px solid #f0f0f0', paddingTop:'16px', marginTop:'4px'}}>
            <p style={{fontSize:'12px', color:'#666', marginBottom:'10px'}}>
              💡 Ayarları kaydettikten sonra test e-postası göndererek bağlantıyı doğrulayın.
            </p>
            <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
              <input
                type="email"
                value={testEmail}
                onChange={e => setTestEmail(e.target.value)}
                placeholder="test@ornek.com"
                style={{flex:1, padding:'7px 10px', border:'1px solid #ddd', borderRadius:'4px', fontSize:'13px'}}
              />
              <button type="button" className="btn btn-outline" onClick={smtpTest} disabled={testYukleniyor} style={{whiteSpace:'nowrap'}}>
                {testYukleniyor ? '⏳ Gönderiliyor...' : '🧪 Test E-postası Gönder'}
              </button>
            </div>
          </div>
        </div>
      )}

      {rolde(kullanici, 'admin', 'mudur') && (
        <div className="card">
          <div className="card-header" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span className="card-title">📱 SMS Ayarları <span style={{fontSize:'12px',color:'#888',fontWeight:'400'}}>(Asist BT SMSProxy)</span></span>
            <button type="button" className="btn btn-outline btn-sm" onClick={() => navigate('/sms-sablonlari')}>📋 SMS Şablonları</button>
          </div>
          <form onSubmit={smsKaydet}>
            <div className="form-grid">
              <div className="form-group" style={{gridColumn:'1/-1',display:'flex',alignItems:'center',gap:'10px'}}>
                <input type="checkbox" id="sms_aktif" checked={!!sms.aktif} onChange={e=>setSms({...sms,aktif:e.target.checked})} style={{width:'18px',height:'18px',flexShrink:0}} />
                <label htmlFor="sms_aktif" style={{margin:0,cursor:'pointer'}}>
                  <strong>SMS Entegrasyonu Aktif</strong>
                  <span style={{color:'#666',marginLeft:'8px',fontWeight:'400',fontSize:'13px'}}>İşaretli olmadığında SMS gönderilmez.</span>
                </label>
              </div>
              <div className="form-group">
                <label>Kullanıcı Adı *</label>
                <input value={sms.kullanici_adi||''} onChange={e=>setSms({...sms,kullanici_adi:e.target.value})} placeholder="Asist BT kullanıcı adı" />
              </div>
              <div className="form-group">
                <label>Şifre <span style={{color:'#999',fontWeight:'400'}}>(boş bırakılırsa değişmez)</span></label>
                <input type="password" value={sms.sifre||''} onChange={e=>setSms({...sms,sifre:e.target.value})} placeholder="•••••• (ayarlı, boş bırakılırsa korunur)" />
              </div>
              <div className="form-group">
                <label>User Code</label>
                <input value={sms.user_code||''} onChange={e=>setSms({...sms,user_code:e.target.value})} placeholder="Asist BT user code" />
              </div>
              <div className="form-group">
                <label>Account ID</label>
                <input value={sms.account_id||''} onChange={e=>setSms({...sms,account_id:e.target.value})} placeholder="Asist BT account id" />
              </div>
              <div className="form-group">
                <label>Originator <span style={{color:'#999',fontWeight:'400'}}>(maks 11 karakter)</span></label>
                <input value={sms.originator||''} onChange={e=>setSms({...sms,originator:e.target.value})} placeholder="UNYE veya 05xxxxxxxxx" maxLength={11} />
              </div>
              <div className="form-group" style={{display:'flex',alignItems:'flex-end'}}>
                <div>
                  <label>SMS Kredisi</label>
                  <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                    {smsKredi !== null && <strong style={{color:'#1b5e20',fontSize:'15px'}}>{smsKredi} kredi</strong>}
                    <button type="button" className="btn btn-outline btn-sm" onClick={smsKrediSorgula}>🔄 Sorgula</button>
                  </div>
                </div>
              </div>
            </div>
            <div style={{marginTop:'16px', display:'flex', justifyContent:'flex-end'}}>
              <button type="submit" className="btn btn-primary">💾 Kaydet</button>
            </div>
          </form>
          <div style={{borderTop:'1px solid #f0f0f0', paddingTop:'16px', marginTop:'4px'}}>
            <p style={{fontSize:'12px', color:'#666', marginBottom:'10px'}}>
              💡 Ayarları kaydettikten sonra test SMS göndererek bağlantıyı doğrulayın.
            </p>
            <div className="form-grid">
              <div className="form-group">
                <label>Test Telefon</label>
                <input value={smsTelefon} onChange={e=>setSmsTelefon(e.target.value)} placeholder="05xxxxxxxxx" />
              </div>
              <div className="form-group">
                <label>Test Mesaj</label>
                <input value={smsMesaj} onChange={e=>setSmsMesaj(e.target.value)} placeholder="Deneme SMS mesajı" />
              </div>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end'}}>
              <button type="button" className="btn btn-outline" onClick={smsTeste} disabled={smsTestYukleniyor}>
                {smsTestYukleniyor ? '⏳ Gönderiliyor...' : '📱 Test SMS Gönder'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header"><span className="card-title">Şifre Değiştir</span></div>
        <form onSubmit={sifreDegistir}>
          <div className="form-grid">
            <div className="form-group"><label>Mevcut Şifre *</label><input type="password" value={sifre.eski_sifre} onChange={e => setSifre({...sifre, eski_sifre: e.target.value})} required /></div>
            <div className="form-group"><label>Yeni Şifre *</label><input type="password" value={sifre.yeni_sifre} onChange={e => setSifre({...sifre, yeni_sifre: e.target.value})} required minLength={6} /></div>
            <div className="form-group"><label>Yeni Şifre (Tekrar) *</label><input type="password" value={sifre.tekrar} onChange={e => setSifre({...sifre, tekrar: e.target.value})} required /></div>
          </div>
          <div style={{marginTop:'16px', display:'flex', justifyContent:'flex-end'}}>
            <button type="submit" className="btn btn-warning">🔑 Şifre Değiştir</button>
          </div>
        </form>
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title">Hesap Bilgileri</span></div>
        <div className="detail-grid">
          <div className="detail-item"><label>Kullanıcı Adı</label><span>{kullanici?.kullanici_adi}</span></div>
          <div className="detail-item"><label>Ad Soyad</label><span>{kullanici?.ad_soyad}</span></div>
          <div className="detail-item"><label>Rol</label><span>{kullanici?.rol}</span></div>
        </div>
      </div>
    </div>
  );
}
